export default __webpack_public_path__ + "static/wedding-6c57946de23f8c7fafff88ca4898ec46.png";